import { render, staticRenderFns } from "./AcademicLoadRow.vue?vue&type=template&id=06e9b36f&scoped=true"
import script from "./AcademicLoadRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicLoadRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AcademicLoadRow.vue?vue&type=style&index=0&id=06e9b36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e9b36f",
  null
  
)

export default component.exports